export default defineNuxtPlugin((app) => {
  const { $globals } = app;

  const cart: any = reactive({
    items: [],
    notAvailableVouchers: computed(() => {
      return cart.items.filter((item) => item?.availableNo == 0);
    }),
    availableVouchers: computed(() => {
      return cart.items.filter((item) => item?.availableNo > 1);
    }),
    totalPrice: computed(() => {
      return cart.items.reduce((acc, item) => {
        acc += item.price * item.quantity;
        return acc;
      }, 0);
    }),
    totalQuantity: computed(() => {
      return cart.items.reduce((acc, item) => {
        acc += item.quantity;
        return acc;
      }, 0);
    }),
    remove: (item) => {
      cart.items.splice(cart.items.indexOf(item), 1);
    },
    add: (item) => {
      cart.items.push(item);
    },
    decrement: (item) => {
      if (item.quantity > 1) item.quantity--;
    },
    increment: (item) => {
      if (item.quantity < ($globals.enabledFeatures.maxQuantity || 10)) {
        item.quantity++;
      }
    },
    load: () => {
      // load cart from storage / api / cookies
      cart.items = [
        {
          id: '1',
          imageUrl:
            'https://staging-p.mondiamedia.com/api/fetch/image/proxy/0x0/aHR0cHM6Ly9zdGFnaW5nLWR1ZmZ5Lm1vbmRpYW1lZGlhLmNvbS9zdHJ1Y3R1cmVhcGkvc3RhZ2UvaW1hZ2VzLzY0LzA4LzdhMmNjNTQwZTM1MDg0ZWJjOWQ3L2ltYWdlLmpwZzszOGVkNzk2YTU1ODI=.jpg',
          name: 'voucher 1',
          description: '{{Platform Selected}}',
          availableNo: 10,
          discountPercentage: '10%',
          price: 4,
          quantity: 1,
          currency: 'EGP',
        },
        {
          id: '2',
          imageUrl:
            'https://staging-p.mondiamedia.com/api/fetch/image/proxy/0x0/aHR0cHM6Ly9zdGFnaW5nLWR1ZmZ5Lm1vbmRpYW1lZGlhLmNvbS9zdHJ1Y3R1cmVhcGkvc3RhZ2UvaW1hZ2VzLzY0LzA4LzdhMmNjNTQwZTM1MDg0ZWJjOWQ3L2ltYWdlLmpwZzszOGVkNzk2YTU1ODI=.jpg',
          name: 'voucher 2',
          description: '{{Platform Selected}}',
          availableNo: 1,
          price: 5,
          quantity: 1,
          currency: 'EGP',
        },
        {
          id: '3',
          imageUrl:
            'https://staging-p.mondiamedia.com/api/fetch/image/proxy/0x0/aHR0cHM6Ly9zdGFnaW5nLWR1ZmZ5Lm1vbmRpYW1lZGlhLmNvbS9zdHJ1Y3R1cmVhcGkvc3RhZ2UvaW1hZ2VzLzY0LzA4LzdhMmNjNTQwZTM1MDg0ZWJjOWQ3L2ltYWdlLmpwZzszOGVkNzk2YTU1ODI=.jpg',
          name: 'voucher 3',
          description: '{{Platform Selected}}',
          availableNo: 0,
          price: 6,
          quantity: 0,
          currency: 'EGP',
        },
        {
          id: '4',
          imageUrl:
            'https://staging-p.mondiamedia.com/api/fetch/image/proxy/0x0/aHR0cHM6Ly9zdGFnaW5nLWR1ZmZ5Lm1vbmRpYW1lZGlhLmNvbS9zdHJ1Y3R1cmVhcGkvc3RhZ2UvaW1hZ2VzLzY0LzA4LzdhMmNjNTQwZTM1MDg0ZWJjOWQ3L2ltYWdlLmpwZzszOGVkNzk2YTU1ODI=.jpg',
          name: 'voucher 4',
          description: '{{Platform Selected}}',
          availableNo: 0,
          price: 7,
          quantity: 0,
          currency: 'EGP',
        },
      ];
    },
    save: () => {
      // push cart to Api/ storage / cookies
    },
  });
  cart.load();
  return {
    provide: { cart },
  };
});
